export enum EmployerReturnToWork {
    FULL_TIME = 'Full-time',
    PART_TIME = 'Part-time',
}